export default __webpack_public_path__ + "static/media/tennis-racket-question-mark.a46daf34.svg";